import { RvProfile } from "processes/RvProfile/RvProfile";

export const RvProfileRouter = RvProfile;
